var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRebetBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "4 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#______src_components_common_betArea_svg_RebetBtn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#______src_components_common_betArea_svg_RebetBtn_svg__b)",
    fillOpacity: 0.85,
    d: "M4 50.5C4 22.886 26.386.5 54 .5s50 22.386 50 50-22.386 50-50 50-50-22.386-50-50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#______src_components_common_betArea_svg_RebetBtn_svg__c)",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    d: "M5 50.5c0-27.062 21.938-49 49-49s49 21.938 49 49-21.938 49-49 49-49-21.938-49-49Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.166 34.23a2.595 2.595 0 0 0-3.27 1.687l-1.022 3.187a21.2 21.2 0 0 0-6.75-6.437 21.1 21.1 0 0 0-16.041-2.354C35.75 33.167 28.875 44.708 31.729 56.042c1.375 5.479 4.833 10.104 9.687 13 3.334 1.979 7.042 3 10.813 3 1.75 0 3.5-.209 5.229-.646 4.187-1.063 7.896-3.313 10.729-6.563a2.583 2.583 0 0 0-.25-3.666 2.583 2.583 0 0 0-3.667.25 15.9 15.9 0 0 1-8.083 4.937c-4.146 1.042-8.437.417-12.104-1.77a15.83 15.83 0 0 1-7.292-9.813c-1.041-4.146-.416-8.438 1.771-12.104 2.188-3.667 5.667-6.25 9.813-7.313a15.9 15.9 0 0 1 12.104 1.771 15.9 15.9 0 0 1 5.166 4.958L61.5 40.75a2.595 2.595 0 0 0-3.271 1.688 2.595 2.595 0 0 0 1.687 3.27l9.625 3.105c.125.041.25.041.354.062h.063c.125 0 .25.063.375.063.416 0 .812-.105 1.187-.292.105-.042.167-.146.271-.208.084-.063.146-.125.23-.188.166-.146.333-.312.458-.5.062-.104.125-.208.166-.312.063-.105.146-.209.167-.313l3.083-9.625a2.595 2.595 0 0 0-1.687-3.27z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_components_common_betArea_svg_RebetBtn_svg__b",
    x1: 4,
    x2: 104,
    y1: 0.5,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12110F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_components_common_betArea_svg_RebetBtn_svg__c",
    x1: 54,
    x2: 54,
    y1: 0.5,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "______src_components_common_betArea_svg_RebetBtn_svg__a",
    width: 108,
    height: 108,
    x: 0,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6524_250007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6524_250007",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebetBtn);
export default __webpack_public_path__ + "static/media/RebetBtn.8ed9749559f0440293df0829dd9e32ef.svg";
export { ForwardRef as ReactComponent };